import InfoText from '@/components/atoms/InfoText';

export const DetailSection = ({
  title,
  items,
  children,
  extraInfo,
  isLoading = false,
}: {
  title: string;
  items?: { label: string; value: React.ReactNode }[];
  children?: React.ReactNode;
  extraInfo?: React.ReactNode;
  isLoading?: boolean;
}) => {
  return (
    <div className="mb-6 bg-soft-background dark:bg-[#1a1a1a] py-4 px-6 border border-[#E7E7E9] dark:border-gray-800 rounded-xl">
      <h3 className="text-gray-900 dark:text-gray-100 font-bold text-lg mb-4">
        {title}
      </h3>

      {items ? (
        <div className="divide-y divide-[#E7E7E9] dark:divide-gray-800">
          {items.map((item, index) => (
            <div
              key={index}
              className="flex justify-between items-center py-4 first:pt-0 last:pb-0"
            >
              <InfoText
                className="!text-light-text-primary"
                text={item.label}
              />

              {isLoading ? (
                <div className="h-5 w-24 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
              ) : typeof item.value === 'string' ||
                typeof item.value === 'number' ? (
                <InfoText
                  className="!text-light-text-primary !font-bold"
                  text={String(item.value)}
                />
              ) : (
                (item.value ?? '-')
              )}
            </div>
          ))}
        </div>
      ) : (
        children
      )}

      {!!extraInfo && <div className="pt-4">{extraInfo}</div>}
    </div>
  );
};
